import React from 'react';
import { Toaster } from 'sonner';
import { useTheme } from '@/contexts/ThemeContext';

/**
 * Sonner's Toaster with the app's resolved theme wired in.
 *
 * Without an explicit `theme` prop sonner defaults to light, so every toast
 * came up as a white card in dark mode — the one piece of UI that always
 * appears on top of whatever you are reading.
 *
 * Note `components/ui/sonner.jsx` also wraps Toaster, but nothing imports it
 * and it pulls `useTheme` from `next-themes`, which this app does not use.
 * This component is the one that is actually mounted.
 */
export default function ThemedToaster(props) {
  const { resolvedTheme } = useTheme();
  return <Toaster theme={resolvedTheme === 'dark' ? 'dark' : 'light'} {...props} />;
}
